import { AnyAction, Reducer } from 'redux';
import { menuActionTypes as actions } from './actions';

export interface MenuState {
  menuIsOpen: boolean;
}

const initialState = {
  menuIsOpen: false
};

export const menuReducer: Reducer<MenuState> = (state: MenuState = initialState, action: AnyAction) => {
  switch (action.type) {
    case actions.OPEN_MENU:
      return {
        ...state,
        menuIsOpen: true
      };
    case actions.CLOSE_MENU:
      return {
        ...state,
        menuIsOpen: false
      };
    case actions.TOGGLE_MENU:
      return {
        ...state,
        menuIsOpen: !state.menuIsOpen
      };

    default:
      return state;
  }
};
